<template>
  <div class="filterContent">
    <el-form inline :model="form">
      <el-row type="flex" justify="space-between">
        <div>
          <el-form-item>
            <el-input v-model="form.operator" :clearable="true" placeholder="操作人姓名"></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <el-date-picker
              unlink-panels
              class="release-select-time"
              v-model="date"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :editable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="状态" v-show="showStatusOption" style="margin-left: 33px">
            <el-select v-model="form.status" clearable placeholder="请选择">
              <el-option
                v-for="item in recordStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="!showUserIdOption">
            <el-button class="filterButton" type="primary" @click="onSearch">筛选</el-button>
          </el-form-item>
        </div>
        <el-form-item v-show="!showStatusOption">
          <el-button class="filterButton" type="plain" @click="onExport">导出数据</el-button>
        </el-form-item>
      </el-row>

        <el-row type="flex" v-show="showUserIdOption" justify="space-between">
          <div>
            <el-form-item>
              <el-input v-model="form.external_userid" :clearable="true" placeholder="external_userid"></el-input>
            </el-form-item>
            <el-form-item style="margin-left: 10px">
              <el-input v-model="form.handover_userid" :clearable="true" placeholder="handover_userid"></el-input>
            </el-form-item>
            <el-form-item style="margin-left: 10px">
              <el-input v-model="form.handover_ntid" :clearable="true" placeholder="handover_NTID"></el-input>
            </el-form-item>
            <el-form-item style="margin-left: 10px">
              <el-input v-model="form.takeover_userid" :clearable="true" placeholder="takeover_userid"></el-input>
            </el-form-item>
            <el-form-item style="margin-left: 10px">
              <el-button class="filterButton" type="primary" @click="onSearch">筛选</el-button>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button class="filterButton" type="plain" @click="onExport">导出数据</el-button>
          </el-form-item>
        </el-row>

    </el-form>
  </div>
</template>

<script>
import { recordStatusList } from '../constrants';
export default {
  name: 'FilterBar',
  props: {
    showStatusOption: {
      type: Boolean,
      default: true,
    },
    // 是否展示 userId 相关筛选项  external_userid，handover_userid，takeover_userid，handover_NTID
    showUserIdOption:{
      type:Boolean,
      default:true,
    }
  },
  data() {
    return {
      recordStatusList,
      form: {
        operator: '',
        external_userid:'',
        handover_userid:'',
        takeover_userid:'',
        handover_ntid:'',
        status: '0',
      },
      date: [],
    };
  },
  methods: {
    onSearch() {
      this.$emit('search', this.form);
    },
    onExport(){
      this.$emit("export",this.form)
    }
  },
};
</script>
